export const SET_PARISH_ID = "setParishId"
export const SET_COLLECTION_INDEX = "setCollectionIndex"
export const INCREASE_COLLECTION_INDEX = "increaseCollectionIndex"
export const DECREASE_COLLECTION_INDEX = "decreaseCollectionIndex"
